"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewEntryType = void 0;
/** Тип объекта оценки */
var ReviewEntryType;
(function (ReviewEntryType) {
  /** Услуга */
  ReviewEntryType[ReviewEntryType["userService"] = 1] = "userService";
  /** Приватный митинг */
  ReviewEntryType[ReviewEntryType["meeting"] = 2] = "meeting";
  /** Коллекция */
  ReviewEntryType[ReviewEntryType["collection"] = 3] = "collection";
})(ReviewEntryType = exports.ReviewEntryType || (exports.ReviewEntryType = {}));
